import { useLocation } from 'js/lib/useRouter';

import { shouldShowLegalConsolidationAuthFlow } from 'bundles/authentication-common/utils';

const useIsInLegalConsolidationFlowAndHasTouQueryParam = () => {
  const { showTouAccept, registrationReferrer } = useLocation().query;
  const isUnregisteredOnboardingSignupFlow = registrationReferrer === 'uvOnboarding';

  return shouldShowLegalConsolidationAuthFlow(isUnregisteredOnboardingSignupFlow) && showTouAccept === '1';
};

export default useIsInLegalConsolidationFlowAndHasTouQueryParam;
